import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ToolbarItemComponent } from './toolbar-item/toolbar-item.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { ToolbarServicesComponent } from './toolbar-services/toolbar-services.component';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { CardtableComponent } from './cardtable/cardtable.component';
import { TableModule } from 'primeng/table';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { DynamicFiltersComponent } from './dynamic-filters/dynamic-filters.component';
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { SubmenuComponent } from './submenu/submenu.component';
import { SubmenuItemComponent } from './submenu-item/submenu-item.component';
import { BookedServiceCardComponent } from './booked-service-card/booked-service-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ToolbarItemActivitiesComponent } from './toolbar-item-activities/toolbar-item-activities.component';
import { ToolbarActivitiesComponent } from './toolbar-activities/toolbar-activities.component';
import { TablePlanningComponent } from './table-planning/table-planning.component';
import { TagModule } from 'primeng/tag';
import { SerialConnectionsComponent } from './serial-connections/serial-connections.component';
import { FormServiceComponent } from './form-service/form-service.component';
import { BookingDialogComponent } from './booking-dialog/booking-dialog.component';
import { PrinterConfigModalComponent } from './printer-config-modal/printer-config-modal.component';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
  declarations: [
    ToolbarComponent,
    ToolbarItemComponent,
    HeaderComponent,
    ToolbarServicesComponent,
    CardtableComponent,
    DynamicFiltersComponent,
    SubmenuComponent,
    SubmenuItemComponent,
    BookedServiceCardComponent,
    ToolbarItemActivitiesComponent,
    ToolbarActivitiesComponent,
    TablePlanningComponent,
    FormServiceComponent,
    SerialConnectionsComponent,
    BookingDialogComponent,
    PrinterConfigModalComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CascadeSelectModule,
    FormsModule,
    DropdownModule,
    CalendarModule,
    MultiSelectModule,
    TableModule,
    ChipModule,
    TooltipModule,
    SliderModule,
    RadioButtonModule,
    DialogModule,
    ReactiveFormsModule,
    CardModule,
    TagModule
  ],
  exports:[
    ToolbarComponent,
    ToolbarItemComponent,
    HeaderComponent,
    ToolbarServicesComponent,
    CardtableComponent,
    DynamicFiltersComponent,
    SubmenuComponent,
    BookedServiceCardComponent,
    ToolbarItemActivitiesComponent,
    ToolbarActivitiesComponent,
    TablePlanningComponent,
    FormServiceComponent,
    SerialConnectionsComponent,
    BookingDialogComponent,
    PrinterConfigModalComponent,
    LoaderComponent
  ],
  providers: [DatePipe],

})
export class ComponentsModule { }
